import { usePrismicQuery } from "../../../hooks/usePrismicQuery";
import { prismicCartSliderQuery } from "../queries";
export function usePrismicCartSliderQuery() {
  return usePrismicQuery(prismicCartSliderQuery);
}